import {DeprecatedDataFrame} from 'data-frames/DataFrameTypes';
import {MakeFieldsRequired} from 'util/Types';

/**
 * Check if a data frame has a column or not
 *
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export default function hasColumn<TDataRow extends object>(
  dataFrame: DeprecatedDataFrame<TDataRow>,
  columnToCheck: string
): boolean {
  return (
    dataFrame.axisTypes.hasOwnProperty(columnToCheck) &&
    dataFrame.points.every((point) => point.hasOwnProperty(columnToCheck))
  );
}

/**
 * Check if a data frame has a column that is optional from its type and narrow the type to indicate if the
 * column is present or not.
 *
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export function hasOptionalColumn<
  TDataRow extends object,
  OptionalColumnName extends keyof TDataRow & string,
>(
  dataFrame: DeprecatedDataFrame<TDataRow>,
  columnToCheck: OptionalColumnName
): dataFrame is DeprecatedDataFrame<MakeFieldsRequired<TDataRow, OptionalColumnName>> {
  return hasColumn(dataFrame, columnToCheck);
}
